'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var reactTracking = require('react-tracking');
var WithAnalytics_types = require('./WithAnalytics.types.js');

var TriggerTypes = {
    CLICK: WithAnalytics_types.TriggerType.CLICK,
    LOAD: WithAnalytics_types.TriggerType.LOAD
};
var createLoadEvent = function (event) {
    return { trigger: WithAnalytics_types.TriggerType.LOAD, event: event };
};
var createClickEvent = function (event) {
    return { trigger: WithAnalytics_types.TriggerType.CLICK, event: event };
};
var getDisplayName = function (WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
//TODO: Need to revisit for types during migration of common utility components
var withAnalytics = function (WrappedComponent) {
    /** Analytics wrapper component to encapsulate  into component with proptypes */
    var AnalyticsWrapper = function (props) {
        var analyticsEvents = props.analyticsEvents, rest = tslib.__rest(props, ["analyticsEvents"]);
        var trackEvent = reactTracking.useTracking().trackEvent;
        var _a = react.useMemo(function () {
            var cEvents = [];
            var lEvents = [];
            if (analyticsEvents && analyticsEvents.length) {
                analyticsEvents.forEach(function (e) {
                    switch (e.trigger) {
                        case WithAnalytics_types.TriggerType.CLICK:
                            cEvents.push(e.event);
                            break;
                        case WithAnalytics_types.TriggerType.LOAD:
                            lEvents.push(e.event);
                            break;
                    }
                });
            }
            return { clickEvents: cEvents, loadEvents: lEvents };
        }, [analyticsEvents]), clickEvents = _a.clickEvents, loadEvents = _a.loadEvents;
        var writeEvent = react.useCallback(function (events) {
            if (events && events.length) {
                events.forEach(function (e) { return trackEvent(e); });
            }
        }, [trackEvent]);
        react.useEffect(function () {
            writeEvent(loadEvents);
        }, [writeEvent, loadEvents]);
        var onClick = function (e) {
            if (rest.onClick) {
                rest.onClick(e);
            }
            writeEvent(clickEvents);
        };
        return jsxRuntime.jsx(WrappedComponent, tslib.__assign({}, rest, { onClick: onClick }));
    };
    AnalyticsWrapper.displayName = "withAnalytics(".concat(getDisplayName(WrappedComponent), ")");
    return AnalyticsWrapper;
};
withAnalytics.TriggerTypes = TriggerTypes;
withAnalytics.createClickEvent = createClickEvent;
withAnalytics.createLoadEvent = createLoadEvent;
var withAnalytics$1 = withAnalytics;

exports.createClickEvent = createClickEvent;
exports.createLoadEvent = createLoadEvent;
exports.default = withAnalytics$1;
exports.withAnalytics = withAnalytics;
//# sourceMappingURL=withAnalytics.js.map
